import LastConfigurations from './LastConfigurations'
import lastConfigurationsContainer from './lastConfigurationsContainer'

export default lastConfigurationsContainer(LastConfigurations)
